import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

interface ScrollAnimateProps {
  children: React.ReactNode;
  animation?: 'fade-in' | 'slide-left' | 'slide-right';
  delay?: number;
  className?: string;
  threshold?: number;
  triggerOnce?: boolean;
}

/**
 * Wrapper component for scroll-triggered animations
 * Usage: <ScrollAnimate animation="fade-in"><YourContent /></ScrollAnimate>
 */
const ScrollAnimate: React.FC<ScrollAnimateProps> = ({
  children,
  animation = 'fade-in',
  delay = 0,
  className = '',
  threshold = 0.1,
  triggerOnce = true,
}) => {
  const { elementRef, isVisible } = useScrollAnimation(threshold, triggerOnce);

  const animationClass = `scroll-${animation}`;
  const visibilityClass = isVisible ? 'visible' : '';

  return (
    <div
      ref={elementRef}
      className={`${animationClass} ${visibilityClass} ${className}`}
      style={{ transitionDelay: `${delay}s` }}
    >
      {children}
    </div>
  );
};

export default ScrollAnimate;
